// extracted by mini-css-extract-plugin
export default {"msgM":"c85fb000e3"};